import { render } from "./AppTestSearch2.vue?vue&type=template&id=402b23ba&scoped=true"
import script from "./AppTestSearch2.vue?vue&type=script&lang=js"
export * from "./AppTestSearch2.vue?vue&type=script&lang=js"

import "./AppTestSearch2.vue?vue&type=style&index=0&id=402b23ba&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-402b23ba"]])

export default __exports__